module.exports = __webpack_public_path__ + "img/user-avatar.638d72aa.png";